import { makeStyles } from "@material-ui/core";
import { Colors } from "../../../helpers/theme";

const mobileWidth = `950px`;
const mobileSmallestWidth = `700px`;
const useStyles = makeStyles((theme) => ({
  emptyProjectContainer: {
    padding: "1.5rem 1rem",
    margin: "1rem 0",
    display: "flex",
    flexDirection: "column",

    border: `2px dashed #f0f1f1`,
    borderRadius: "10px",

    "& > *:nth-child(odd)": {
      backgroundColor: Colors.darkWhite,
    },

    [`@media(max-width: ${mobileWidth})`]: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(250px, 1fr))",
      gridTemplateRows: "repeat(4, max-content)",
      gap: "1rem",

      "& > *:nth-child(odd)": {
        background: "unset",
      },
    },

    [`@media(max-width: ${mobileSmallestWidth})`]: {
      gridTemplateColumns: "1fr",
    },
  },
  emptyProjectItem: {
    display: "grid",
    padding: "1rem .5rem",
    borderWidth: "0 !important",

    gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
    gridAutoRows: "2rem",

    alignItems: "center",
    justifyItems: "center",

    gridTemplateAreas: `"project_avatar project_info project_raised_label project_raised_value project_ath_label project_ath_value project_network_image"`,

    [`@media(max-width: ${mobileWidth})`]: {
      gridTemplateAreas: `
        "project_avatar project_network_image"
        "project_raised_label project_raised_value"
        "project_ath_label project_ath_value"
      `,
      justifyItems: "unset",
      padding: "1rem",
      gridTemplateRows: "max-content",
      gridAutoRows: "1rem",

      borderWidth: "unset !important",
    },
  },

  infoWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  avatar: {
    width: "48px !important",
    height: "48px !important",

    gridArea: "project_avatar",
  },
  network: {
    height: "32px !important",
    width: "32px !important",
    gridArea: "project_network_image",

    [`@media(max-width: ${mobileWidth})`]: {
      justifySelf: "end",
    },
  },
  totalRaisedLabel: {
    gridArea: "project_raised_label",
  },
  totalRaisedValue: {
    gridArea: "project_raised_value",

    [`@media(max-width: ${mobileWidth})`]: {
      justifySelf: "end",
    },
  },
  athLabel: {
    gridArea: "project_ath_label",
  },
  athValue: {
    gridArea: "project_ath_value",

    [`@media(max-width: ${mobileWidth})`]: {
      justifySelf: "end",
    },
  },
}));

export default useStyles;
